{
  "partnership_invitations": {
    "navigation_title": "Invitaciones",
    "title": "Invitaciones",
    "invite_new_partner": "Invitar un asociado",
    "address_label": "Correo electrónico de contacto",
    "address_placeholder": "correo electrónico del administrador o identificación de la organización",
    "invalid_address": "La dirección de la organización es desconocida.",
    "organization_from_email_not_unique": "La organización no pudo identificarse mediante la dirección de correo electrónico",
    "invite_button": "Enviar invitación",
    "inviting_org_label": "Invitar a una organización",
    "empty_list": "No hay invitaciones para asociados"
  }
}
